// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__QIYcb","slider":"Toggle_slider__YBfre","round":"Toggle_round__CNIcj"};